import {
  PrevailingWageFringeOvertimeTreatment,
  PrevailingWageOvertimeScope,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import * as yup from 'yup';

import { OvertimeRule } from '~hooks/useOvertimeRule/models';

export const overtimeRuleSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  scope: yup
    .string()
    .oneOf(Object.values(PrevailingWageOvertimeScope))
    .required(t('form_validation_errors.required_simple')),
  daily_threshold_hours: yup
    .number()
    .nullable()
    .transform((value, original) =>
      original === '' || original === null || original === undefined ? null : value,
    )
    .min(0, t('form_validation_errors.minimum_is_num', { num: 0 })),
  weekly_threshold_hours: yup
    .number()
    .required(t('form_validation_errors.required_simple'))
    .min(0, t('form_validation_errors.minimum_is_num', { num: 0 })),
  weekly_threshold_days: yup
    .number()
    .nullable()
    .transform((value, original) =>
      original === '' || original === null || original === undefined ? null : value,
    )
    .integer(
      t('form_validation_errors.should_be_integer', {
        field: t('form_fields.weekly_threshold_days'),
      }),
    )
    .min(0, t('form_validation_errors.minimum_is_num', { num: 0 })),
  multiplier: yup
    .number()
    .required(t('form_validation_errors.required_simple'))
    .positive(t('form_validation_errors.minimum_is_num', { num: 0.01 })),
  double_time_threshold_hours: yup
    .number()
    .nullable()
    .transform((value, original) =>
      original === '' || original === null || original === undefined ? null : value,
    )
    .min(0, t('form_validation_errors.minimum_is_num', { num: 0 })),
  double_time_multiplier: yup
    .number()
    .nullable()
    .transform((value, original) =>
      original === '' || original === null || original === undefined ? null : value,
    )
    .positive(t('form_validation_errors.minimum_is_num', { num: 0.01 })),
  fringe_treatment: yup
    .string()
    .oneOf(Object.values(PrevailingWageFringeOvertimeTreatment))
    .required(t('form_validation_errors.required_simple')),
});

export type OvertimeRuleDto = yup.InferType<typeof overtimeRuleSchema>;

export type OvertimeRuleDtoAsyncError = {
  field: keyof OvertimeRuleDto;
  message: string;
};

export const setOvertimeRuleSchemaDefaultValues = (
  overtimeRule?: OvertimeRule,
): OvertimeRuleDto => {
  return {
    name: overtimeRule?.name ?? '',
    scope: overtimeRule?.scope ?? PrevailingWageOvertimeScope.PW_HOURS_ONLY,
    daily_threshold_hours: overtimeRule?.dailyThresholdHours ?? null,
    weekly_threshold_hours: overtimeRule?.weeklyThresholdHours ?? 40,
    weekly_threshold_days: overtimeRule?.weeklyThresholdDays ?? null,
    multiplier: overtimeRule?.multiplier ?? 1.5,
    double_time_threshold_hours: overtimeRule?.doubleTimeThresholdHours ?? null,
    double_time_multiplier: overtimeRule?.doubleTimeMultiplier ?? null,
    fringe_treatment:
      overtimeRule?.fringeTreatment ??
      PrevailingWageFringeOvertimeTreatment.STRAIGHT_TIME,
  };
};
